module.exports = ".wrapper.closed{\n    height:78px;\n    margin-top:80px;\n}\n.blur\n{\n    -webkit-filter: blur(5px);\n  filter: blur(5px);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/budget/wrapper/wrapper.component.css
// module id = ./src/app/components/budget/wrapper/wrapper.component.css
// module chunks = main